import { isDevMode, Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class DevModeService {
  public isDevMode() {
    return isDevMode();
  }
}
